import { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { get, invert } from 'lodash';
import { SORTING_ORDER_TYPES } from 'taboola-ultimate-ui';
import { useCurrentValueGetter } from '../../../hooks';
import { setCampaignPickerSorting } from '../../../modules/campaigns/actions';
import { CAMPAIGN_SORTABLE_FIELDS, defaultSortField, defaultSortType } from '../../../modules/campaigns/config';
import { campaignPickerSortOptionsSelector } from '../../../modules/campaigns/selectors';

export const SORTABLE_FIELD_VALUE_TO_KEY_MAP = invert(CAMPAIGN_SORTABLE_FIELDS);
export const SORTING_ORDER_TYPE_TO_KEY_MAP = invert(SORTING_ORDER_TYPES);

const getValidValue = (value, validValues, defaultValue) => (validValues[value] ? value : defaultValue);
export const useCampaignPickerSorting = () => {
    const dispatch = useDispatch();
    const { type, field } = useSelector(campaignPickerSortOptionsSelector);
    const sortField = getValidValue(field, SORTABLE_FIELD_VALUE_TO_KEY_MAP, defaultSortField);
    const sortType = getValidValue(type, SORTING_ORDER_TYPE_TO_KEY_MAP, defaultSortType);
    const sort = useMemo(
        () => [
            {
                field: sortField,
                order: sortType,
            },
        ],
        [sortField, sortType]
    );
    const sortGetter = useCurrentValueGetter(sort);
    const setSort = useCallback(
        newSort => {
            const newField = get(newSort, '0.field');
            const newType = get(newSort, '0.order');

            if (newField) {
                dispatch(setCampaignPickerSorting({ campaignPickerSortingField: newField }));
            }
            if (newType) {
                dispatch(setCampaignPickerSorting({ campaignPickerSortingType: newType }));
            }
        },
        [dispatch]
    );

    return {
        sortField,
        sortType,
        sort,
        sortGetter,
        setSort,
    };
};
